import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isDevlakeSquad } from '../shared/devlakeSquad';

export const devlakeGithubContent = EntityContentBlueprint.make({
  name: 'devlake-github',
  params: {
    path: '/github-metrics',
    title: 'GitHub metrics',
    group: 'devlake-github',
    filter: isDevlakeSquad,
    loader: async () => {
      const { GithubMetricsContent } = await import('./GithubMetricsContent');
      return <GithubMetricsContent />;
    },
  },
});

export const devlakeGithubModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [devlakeGithubContent],
});
